export const env = {
    REACT_APP_API_BASE_URL : "https://tbi-gg-flightb2b.uat.tbidevelopment.ca",
    REACT_APP_STATIC_CONTENT : "https://tbi-gg-static.uat.tbidevelopment.ca",
    REACT_APP_PROFILE_ORG_BASE_URL : "https://tbi-gg-profile.uat.tbidevelopment.ca", 
    REACT_APP_FRAUD_CHECK_URL : "https://tbi-gg-fraud.uat.tbidevelopment.ca",
	SKIP_PREFLIGHT_CHECK : "true",
    REACT_APP_HEADER_URL : "https://access.travelbrandsagent.com/common/header",
    REACT_APP_FOOTER_URL : "https://access.travelbrandsagent.com/common/footer",
    REACT_APP_HEADER_URL_FRENCH : "https://access.travelbrandsagent.com/common/header?lang=fr",
    REACT_APP_FOOTER_URL_FRENCH : "https://access.travelbrandsagent.com/common/footer?lang=fr",
    REACT_APP_NEW_HEADER_URL : "https://access.travelbrandsagent.com/common/header",
    REACT_APP_NEW_FOOTER_URL : "https://access.travelbrandsagent.com/common/footer",
    REACT_APP_FLIGHT_LOGO_URL : "https://travel-img-assets.s3.us-west-2.amazonaws.com/common/logos/carrier-logos-48x48",
    REACT_APP_NOTIFICATION_API : "https://tbi-gg-notification.uat.tbidevelopment.ca",
    isProd:false,
    AIRTABLE_SECRET_KEY:"patFzlwn6j6u0nlMn.e244c7a86a55cd914e5e8b44076a8f93938b85b4228227780abe2e1fe92cbb4a",
    AIRTABLE_URL:"https://api.airtable.com/v0/appE8BGP7cRjLAcTL",
    PAYMENT_URL:"https://tbi-gg-paymentapi.uat.tbidevelopment.ca",
    CENTRALIZED_EMAIL_URL: "https://tbi-gg-email-service.uat.tbidevelopment.ca",
    REACT_APP_API_CORE_BASE_URL : "https://tbi-gg-flightcore.uat.tbidevelopment.ca",
    TRAVELBRANDS_AGENT_URL : "https://travelbrandsagent.com/Login.aspx",
    TBIDEVELOPMENT_URL : "https://access-uat.travelbrandsagent.com/login",
    RELAY_SERVICE: "https://tbi-gg-sv-proxy.dev.tbidevelopment.ca/proxyReq",
    ACCESS_LOGIN_URL: "https://tbi-profile-service.dev.tbidevelopment.ca",
    INVOICE_URL: "http://10.96.30.82/GestionVIT/GIGI_Invoices.php",
    GOLDEN_TICKET_HEADER_LOGO: "https://tbi-profile-management-logos.s3.ca-central-1.amazonaws.com/email-template-logos/goldenTicketLogo.jpeg",
    GOLDEN_TICKET_AGENCY_PHONE: "7504547323",
    ACCESS_API_URL: "https://tbi-profile-service.prod.tbidevelopment.ca",
    TTS_WEBSERVICE_URL: "https://webservices-ext.travelbrands.com/tcdevelopment/tcnaapi/service.asmx/GetResponse",
    NOTIFICATION_API_URL: "https://tbi-notification-service.tbidevelopment.ca/notificationtemplate",
    TEMP_REGISTER_AGENT_PASS: "TEMPPW2025",
    VERIFY_EMAIL_TEMPLATE_ID_EN: "18dfa6b7-6465-4c96-90fe-854e12d334c3",
    VERIFY_EMAIL_TEMPLATE_ID_FR: "5399852c-27ed-4359-bbee-c6c5f8d963d5",
    TTS_USERNAME: "TCNAB2B",
    TTS_PASSWORD: "LEAFS",
    TTS_REQUEST: "AGENTPROFILE",
    TTS_TIMEOUT_MS: "300000",
    VERIFICATION_TOKEN_LENGTH: "30",
    AGENT_REGISTER_NEWSLETTER_SUBSCRIPTION: "unsubscribe",
    AGENT_REGISTER_ALLOW_PUSH: "N",
    AGENT_REGISTER_DEFAULT_INTERESTS: "",
    AGENT_REGISTER_DEFAULT_LANGUAGE: "en",
    DEFAULT_AGENCY_PHONE: "7504547323",
    AGENT_REGISTER_CALL_APIS: "true"
}
